import styled from 'styled-components';
import { ReactComponent as Whatsapp } from '../../../assets/icons/whatsapp.svg';
import { ReactComponent as SMS } from '../../../assets/icons/chat-bubble-line.svg';
import { ReactComponent as RadioButtonSVG } from '../../../assets/icons/radio-button.svg';
import { ReactComponent as RadioButtonCheckedSVG } from '../../../assets/icons/radio-checked.svg';

type OptionChecked = {
  whatsapp?: boolean;
  sms?: boolean;
};

type WppChecked = {
  wpp: boolean;
};

type SmsChecked = {
  sms: boolean;
};

export const SMSWhatsapp = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 15px;
  height: auto;
  box-shadow: -4px -4px 8px rgba(36, 36, 36, 0.1),
    4px 4px 6px rgba(36, 36, 36, 0.1);
  border-radius: ${(props) =>
    Number(props.theme.radiusCards) ? `${props.theme.radiusCards}px` : '60px'};

  margin: 12px 0;
  background: #fff;
  padding: 20px 26px 20px 34px;
  box-sizing: border-box;

  &:hover {
    cursor: pointer;
  }

  @media screen and (max-width: 960px) {
    border-radius: ${(props) =>
      Number(props.theme.radiusCards)
        ? `${props.theme.radiusCards}px`
        : '10px'};
    width: 100%;
    padding: 20px 17px;
    font-size: 14px;
    height: auto;
  }
`;

export const IconSMS = styled(SMS)`
  width: 28px;
  height: 28px;
`;

export const IconWhatsapp = styled(Whatsapp)`
  width: 28px;
  height: 28px;
`;

export const Options = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  .wpp-section {
    margin-right: 10%;
  }
  .sms-section {
    margin-left: 9%;
  }

  @media screen and (max-width: 960px) {
    width: 95%;
    justify-content: space-between;
    .wpp-section {
      margin-right: 0;
    }
    .sms-section {
      margin-left: 0;
    }
  }

  @media screen and (max-width: 600px) {
    width: 100%;
    justify-content: flex-start;
    flex-direction: column;
    align-items: flex-start;

    .wpp-section {
      margin-right: 0;
    }
    .sms-section {
      margin-left: 0;
    }
  }
`;

export const Section = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 40%;
  height: 28px;

  @media screen and (max-width: 960px) {
    width: auto;
    justify-content: flex-start;
    margin-bottom: 0;
  }

  @media screen and (max-width: 600px) {
    width: 100%;
    justify-content: space-between;
  }
`;

export const WhatsAppOption = styled.span`
  display: flex;
  align-items: center;
  justify-content: flex-start;

  @media screen and (max-width: 960px) {
    margin-bottom: 0;
  }
`;

export const SMSOption = styled.span`
  display: flex;
  align-items: center;
  justify-content: flex-start;

  @media screen and (max-width: 960px) {
    margin-top: 0;
  }
`;

export const TextOption = styled.div`
  width: 160px;
  font-family: ${(props) => props.theme.primaryFont};
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 14px;
  margin-left: 16px;
  color: #222222;

  @media screen and (max-width: 960px) {
  }
`;

export const Info = styled.span`
  font-family: ${(props) => props.theme.primaryFont};
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 16px;
  color: #222222;
  width: auto;
  padding-bottom: 8px;
`;

export const SelectWhatsapp = styled.div<WppChecked>`
  display: flex;
  align-items: center;
  justify-content: center;
  border: ${(props) =>
    `2px solid ${props.wpp ? props.theme.colors.primary : '#7B86A3'}`};
  min-height: 24px;
  min-width: 24px;
  border-radius: 50%;
  align-self: center;
  cursor: pointer;
  span {
    background: ${(props) => (props.wpp ? props.theme.colors.primary : 'none')};
    align-self: center;
    justify-self: center;
    height: 14px;
    width: 14px;
    border-radius: 50%;
  }
`;

export const SelectSMS = styled.div<SmsChecked>`
  display: flex;
  align-items: center;
  justify-content: center;
  border: ${(props) =>
    `2px solid ${props.sms ? props.theme.colors.primary : '#7B86A3'}`};
  min-height: 24px;
  min-width: 24px;
  border-radius: 50%;
  align-self: center;
  cursor: pointer;
  span {
    background: ${(props) => (props.sms ? props.theme.colors.primary : 'none')};
    align-self: center;
    justify-self: center;
    height: 14px;
    width: 14px;
    border-radius: 50%;
  }
`;
